import { type FC } from 'react';

import { type LearnerActivityStats } from 'connect-graphql/generated';

import { MultiToneProgressBar } from '@craft/ui/components/progress';
import { Stack } from '@craft/ui/components/structural';
import { Typography } from '@craft/ui/components/typography';

type LearnerProgressBarProps = {
  readonly progress: { returned?: number } & Pick<LearnerActivityStats, 'approved' | 'pending'>;
};

export const LearnerProgressBar: FC<LearnerProgressBarProps> = ({
  progress: { approved, pending, returned = 0 },
}) => (
  <Stack alignItems='center' direction='row' flex={1} gap={1}>
    <Stack flex={1}>
      <MultiToneProgressBar
        aria-label='learner progress bar'
        segments={[
          { color: 'success.main', value: approved },
          { color: 'warning.main', value: returned },
          { color: 'pending.main', value: pending },
        ]}
      />
    </Stack>
    <Typography color='text.secondary' minWidth={35} textAlign='right' variant='body2'>
      {approved}%
    </Typography>
  </Stack>
);
